import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch {
      toast.error('Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#1e3a5f] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#f0a500] rounded-2xl mb-4 shadow-lg">
            <span className="text-white font-bold text-3xl">KU</span>
          </div>
          <h1 className="text-white text-2xl font-bold">Krishna Uday & Associates</h1>
          <p className="text-blue-300 text-sm mt-1">Chartered Accountants, Hyderabad</p>
          <p className="text-blue-200 text-xs mt-3 opacity-70">Practice Management System</p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-[#1e3a5f] font-bold text-xl mb-6">Sign In</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                className="input-field" placeholder="admin@kuassociates.com" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                className="input-field" placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#1e3a5f] hover:bg-[#264873] text-white font-semibold py-3 rounded-lg transition-colors mt-2 disabled:opacity-60">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>


        </div>

        <p className="text-center text-blue-300 text-xs mt-6 opacity-60">
          Internal use only — Krishna Uday & Associates © 2025
        </p>
      </div>
    </div>
  );
}
